import { AxiosPromise } from 'axios';
import request from '@/utils/request';

/**
 * 球员版本列表
  GET /product/api/fifa/player/version/list
  接口ID：255666436
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-255666436
 */
export const getPlayerVersionOption = (): AxiosPromise<string[]> => {
  return request({
    url: '/product/api/fifa/player/version/list',
    method: 'get'
  });
};

/**
 * 球员位置列表
  GET /product/api/fifa/player/position/list
  接口ID：255666437
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-255666437
 */
export const getPlayerPositionOption = (): AxiosPromise<string[]> => {
  return request({
    url: '/product/api/fifa/player/position/list',
    method: 'get'
  });
};
